(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cp-hero').forEach(function(root){
    var slides = root.querySelectorAll('.cp-hero__slide'), dots = root.querySelectorAll('.cp-hero__dot'), i = 0, t;
    if (slides.length < 2) return;
    function go(n){ slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden','true'); dots[i] && dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length; slides[i].classList.add('is-active'); slides[i].setAttribute('aria-hidden','false'); dots[i] && dots[i].classList.add('is-active'); }
    function arm(){ clearInterval(t); if (root.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) t = setInterval(function(){ go(i+1); }, (parseInt(root.dataset.speed,10)||6)*1000); }
    root.querySelectorAll('.cp-hero__arrow').forEach(function(b){ b.addEventListener('click', function(){ go(i + parseInt(b.dataset.dir,10)); arm(); }); });
    dots.forEach(function(d){ d.addEventListener('click', function(){ go(parseInt(d.dataset.i,10)); arm(); }); });
    root.addEventListener('mouseenter', function(){ clearInterval(t); }); root.addEventListener('mouseleave', arm);
    arm();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-popup"]) return;
  try {
    
  document.querySelectorAll('.cp-pop').forEach(function(p){
    var key = p.dataset.key, seen = false;
    try { seen = localStorage.getItem(key) === '1'; } catch(e){}
    if (seen && !(window.Shopify && window.Shopify.designMode)) return;
    function close(){ p.hidden = true; try { localStorage.setItem(key,'1'); } catch(e){} }
    setTimeout(function(){ p.hidden = false; }, (parseInt(p.dataset.delay,10)||4)*1000);
    p.querySelector('.cp-pop__close').addEventListener('click', close);
    p.addEventListener('click', function(e){ if (e.target === p) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
    var f = p.querySelector('form'); if (f) f.addEventListener('submit', function(){ try { localStorage.setItem(key,'1'); } catch(e){} });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
